import React from "react";
import "../../styles/clinica.css";
import semFoto from "../../img/corpoClinico/sem_foto.jpg";
import DepoimentoOne from "../../img/depoimentos/depoimentoOne.jpg";
import DepoimentoTwo from "../../img/depoimentos/depoimentoTwo.jpg";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faStar } from "@fortawesome/free-solid-svg-icons";


const DepoimentoCard: React.FC = () => {
  return (
    <>

      <div>
        <h2 className='depoimentos_clinica'>Depoimentos</h2>

        <div className="depoimento-cards-container">
          {/* Card 1 */}
          <div className="depoimento-card">
            <div className="depoimento-logo">
              <img src={DepoimentoOne} alt="Paciente 1" />
            </div>
            <div className="depoimento-content">
              <p className="depoimento-nome">Sabrina De Lima</p>
              <p className="depoimento-data">20/04/2025</p>
              <p className="depoimento-estrelas">
                <FontAwesomeIcon icon={faStar} />
                <FontAwesomeIcon icon={faStar} />
                <FontAwesomeIcon icon={faStar} />
                <FontAwesomeIcon icon={faStar} />
                <FontAwesomeIcon icon={faStar} />
              </p>
              <p className="depoimento-msg">Esse ano completamos 7 anos de caminhada ao lado da Clínica Mediação, não poderia deixar de expressar minha profunda gratidão pela acolhida e caminhada com o Cássio e toda nossa família. Cada sessão, cada escuta atenta, cada orientação e cada conquista fizeram parte de um processo transformador que me ajudou a crescer, me entender e me fortalecer como mãe atípica.

                Agradeço de coração a toda a equipe da Mediação e principalmente a Gigi, que sempre nos recebeu com amor, respeito, empatia e profissionalismo. Vocês fizeram e continuam fazendo a diferença na minha vida.

                Que venham mais etapas, mais aprendizados e mais motivos para agradecer.
                Obrigada por tudo!</p>
            </div>
          </div>

          {/* Card 2 */}
          <div className="depoimento-card">
            <div className="depoimento-logo">
              <img src={DepoimentoTwo} alt="Paciente 1" />
            </div>
            <div className="depoimento-content">
              <p className="depoimento-nome">Léo</p>
              <p className="depoimento-data">20/04/2025</p>
              <p className="depoimento-estrelas">
                <FontAwesomeIcon icon={faStar} />
                <FontAwesomeIcon icon={faStar} />
                <FontAwesomeIcon icon={faStar} />
                <FontAwesomeIcon icon={faStar} />
                <FontAwesomeIcon icon={faStar} />
              </p>
              <p className="depoimento-msg">O Léo faz acompanhamento na clínica Mediação desde dezembro de 2021. Ele tem TEA e TDAH, e no início era muito agitado, não conseguia sentar, ouvir ou se comunicar.
                Hoje, com o tratamento, ele está mais calmo, escuta, brinca, se comunica e mostra toda a sua inteligência. Ao longo desses anos, o atendimento da clínica sempre foi excelente, com uma recepção acolhedora e um cuidado verdadeiro com cada paciente.
                A Gilca é uma profissional dedicada, que se preocupa de fato com o desenvolvimento das crianças. O trabalho realizado aqui é excepcional e faz toda a diferença na vida de quem passa por esse espaço.</p>
            </div>
          </div>

          {/* Card 3 */}
          <div className="depoimento-card">
            <div className="depoimento-logo">
              <img src={semFoto} alt="Paciente 1" />
            </div>
            <div className="depoimento-content">
              <p className="depoimento-nome">Ivan Pedro</p>
              <p className="depoimento-data">22/08/025</p>
              <p className="depoimento-estrelas">
                <FontAwesomeIcon icon={faStar} />
                <FontAwesomeIcon icon={faStar} />
                <FontAwesomeIcon icon={faStar} />
                <FontAwesomeIcon icon={faStar} />
                <FontAwesomeIcon icon={faStar} />
              </p>
              <p className="depoimento-msg">Sou um autista grau leve e venho sendo acompanhado pela Gigi, na Clínica Mediação, por mais de 15 anos, desde meus 7 anos. Hoje tenho 24 anos, mas  o vínculo e a confiança permanecem, pois nesse espaço encontrei acolhimento, orientação e algumas amizades para a vida toda. Os profissionais da clínica se tornaram quase uma família para mim. Com esse auxílio, somado a minha força e minha determinação para lutar, muitas dificuldades próprias do autismo foram superadas. Hoje sou mais tranquilo, paciente com as diversas situações do dia a dia. Recomendo a Clínica para todos que possam ter uma situação semelhante à minha e  agradeço muito a oportunidade de poder fazer parte da grande família da Gigi.</p>
            </div>
          </div>
        </div>
      </div>
    </>
  );
};

export default DepoimentoCard;
